module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.spinnerVisible) ? _c('div', {
    staticClass: "spinner"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-4x"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8d4fac4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = 174
// module chunks = 1